import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=7ff0fdf2&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=7ff0fdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0fdf2",
  null
  
)

/* custom blocks */
import block0 from "./Prompt.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports